import React, { useRef } from 'react';
import html2canvas from 'html2canvas';

// 일러스트 이미지 import
const babyImages = {
  '0-3_common': '/images/baby_0-3_common.png',
  '4-6_common': '/images/baby_4-6_common.png',
  '7-9_boy': '/images/baby_7-9_boy.png',
  '7-9_girl': '/images/baby_7-9_girl.png',
  '10-12_boy': '/images/baby_10-12_boy.png',
  '10-12_girl': '/images/baby_10-12_girl.png',
  '13-18_boy': '/images/baby_13-18_boy.png',
  '13-18_girl': '/images/baby_13-18_girl.png',
};

function ShareCard({ profile, latestRecord, babyAge, onClose }) {
  const cardRef = useRef(null);

  // 날짜 형식 변환 (2025-10-24 → 25.10.24)
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${year.slice(2)}.${month}.${day}`;
  };

  // 받침 확인 함수
  const hasFinalConsonant = (name) => {
    if (!name || name.length === 0) return false;
    const lastChar = name.charAt(name.length - 1);
    const code = lastChar.charCodeAt(0);
    if (code >= 0xAC00 && code <= 0xD7A3) {
      return (code - 0xAC00) % 28 !== 0;
    }
    return false;
  };

  // 조사 선택 함수
  const getParticle = (name, withConsonant, withoutConsonant) => {
    return hasFinalConsonant(name) ? withConsonant : withoutConsonant;
  };

  const getAgeText = (months) => {
    const years = Math.floor(months / 12);
    const remainingMonths = months % 12;

    if (years === 0) {
      return `${remainingMonths}개월`;
    } else if (remainingMonths === 0) {
      return `${years}년`;
    } else {
      return `${years}년 ${remainingMonths}개월`;
    }
  };

  // 나이에 맞는 아기 이미지 선택
  const getBabyImage = (months, gender) => {
    if (months <= 3) return babyImages['0-3_common'];
    if (months <= 6) return babyImages['4-6_common'];
    if (months <= 9) return babyImages[`7-9_${gender}`];
    if (months <= 12) return babyImages[`10-12_${gender}`];
    return babyImages[`13-18_${gender}`]; // 13개월 이상은 모두 13-18 이미지 사용
  };

  const handleDownload = async () => {
    try {
      const element = cardRef.current;
      const canvas = await html2canvas(element, {
        backgroundColor: '#FAF3E8',
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        imageTimeout: 0
      });

      const link = document.createElement('a');
      link.download = `${profile.name}_성장기록_${new Date().toISOString().split('T')[0]}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();

      alert('이미지가 다운로드되었습니다!');
    } catch (error) {
      console.error('이미지 생성 실패:', error);
      alert('이미지 생성에 실패했습니다.');
    }
  };

  const handleShare = async () => {
    try {
      const element = cardRef.current;
      const canvas = await html2canvas(element, {
        backgroundColor: '#FAF3E8',
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        imageTimeout: 0
      });

      canvas.toBlob(async (blob) => {
        const file = new File([blob], `${profile.name}_성장기록.png`, { type: 'image/png' });

        if (navigator.share) {
          try {
            await navigator.share({
              title: `${profile.name} 성장 기록`,
              text: `우리 ${profile.name}${getParticle(profile.name, '은', '는')} ${getAgeText(babyAge)}이에요!`,
              files: [file]
            });
          } catch (err) {
            if (err.name !== 'AbortError') {
              console.error('공유 실패:', err);
              alert('공유하기가 지원되지 않는 브라우저입니다. 이미지를 다운로드해서 직접 공유해주세요.');
              handleDownload();
            }
          }
        } else {
          alert('공유하기가 지원되지 않는 브라우저입니다. 이미지를 다운로드해서 직접 공유해주세요.');
          handleDownload();
        }
      });
    } catch (error) {
      console.error('공유 실패:', error);
      alert('공유 준비 중 오류가 발생했습니다.');
    }
  };

  if (!latestRecord) {
    return (
      <div className="fade-in" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: '20px'
      }}>
        <div className="slide-up" style={{
          backgroundColor: 'white',
          borderRadius: '24px',
          padding: '40px',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
          <h3 style={{ color: '#E8A87C', marginBottom: '8px' }}>기록이 없습니다</h3>
          <p style={{ color: '#8B7355', fontSize: '14px' }}>먼저 성장 기록을 추가해주세요.</p>
          <button
            onClick={onClose}
            style={{
              marginTop: '20px',
              padding: '12px 24px',
              backgroundColor: '#E8A87C',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            닫기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fade-in" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '40px 20px',
      overflow: 'auto'
    }}>
      <div className="slide-up" style={{
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '500px',
        width: '100%',
        position: 'relative',
        maxHeight: '90vh',
        overflow: 'auto',
        margin: '20px 0'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#8B7355'
          }}
        >
          ×
        </button>

        <div style={{
          textAlign: 'center',
          marginBottom: '24px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📤</div>
          <h2 style={{
            color: '#E8A87C',
            fontSize: '24px',
            marginBottom: '8px'
          }}>
            성장 기록 공유
          </h2>
          <p style={{
            color: '#8B7355',
            fontSize: '14px'
          }}>
            카톡, 인스타 등으로 공유하세요
          </p>
        </div>

        {/* 공유할 카드 */}
        <div
          ref={cardRef}
          style={{
            backgroundColor: '#FAF3E8',
            borderRadius: '28px',
            padding: '32px',
            marginBottom: '24px',
            border: '3px solid #E8A87C',
            boxShadow: '0 4px 16px rgba(232, 168, 124, 0.12)'
          }}
        >
          <div style={{
            textAlign: 'center',
            marginBottom: '24px'
          }}>
            <img
              src={getBabyImage(babyAge, profile.gender)}
              alt="baby"
              style={{
                width: '200px',
                height: '200px',
                objectFit: 'contain',
                display: 'block',
                margin: '0 auto 16px',
                borderRadius: '24px'
              }}
            />
            <h3 style={{
              color: '#E8A87C',
              fontSize: '28px',
              marginBottom: '8px',
              fontWeight: 'bold'
            }}>
              {profile.name}
            </h3>
            <p style={{
              color: '#8B7355',
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              {getAgeText(babyAge)}
            </p>
          </div>

          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '20px',
            marginBottom: '16px'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              textAlign: 'center'
            }}>
              <div>
                <div style={{ fontSize: '32px', marginBottom: '8px' }}>📏</div>
                <div style={{
                  color: '#E8A87C',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '4px'
                }}>
                  {latestRecord.height}cm
                </div>
                <div style={{ color: '#8B7355', fontSize: '12px' }}>키</div>
              </div>
              <div>
                <div style={{ fontSize: '32px', marginBottom: '8px' }}>⚖️</div>
                <div style={{
                  color: '#D4956B',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '4px'
                }}>
                  {latestRecord.weight}kg
                </div>
                <div style={{ color: '#8B7355', fontSize: '12px' }}>몸무게</div>
              </div>
            </div>
          </div>

          <div style={{
            textAlign: 'center',
            color: '#8B7355',
            fontSize: '12px'
          }}>
            측정일: {formatDate(latestRecord.date)}
          </div>

          <div style={{
            marginTop: '20px',
            paddingTop: '20px',
            borderTop: '2px dashed #E8A87C',
            textAlign: 'center'
          }}>
            <div style={{
              color: '#E8A87C',
              fontSize: '16px',
              fontWeight: 'bold'
            }}>
              🍼 bebé note
            </div>
            <div style={{
              color: '#8B7355',
              fontSize: '11px',
              marginTop: '4px'
            }}>
              우리 아기 성장 기록
            </div>
          </div>
        </div>

        {/* 버튼들 */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '12px'
        }}>
          <button
            onClick={handleDownload}
            style={{
              padding: '16px',
              backgroundColor: 'white',
              border: '2px solid #E8A87C',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#E8A87C',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            💾 이미지 저장
          </button>
          <button
            onClick={handleShare}
            style={{
              padding: '16px',
              backgroundColor: '#E8A87C',
              border: 'none',
              borderRadius: '12px',
              fontSize: '15px',
              fontWeight: 'bold',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            📤 공유하기
          </button>
        </div>

        <p style={{
          textAlign: 'center',
          color: '#8B7355',
          fontSize: '11px',
          marginTop: '16px'
        }}>
          💡 공유하기가 안 되면 이미지를 저장해서 직접 공유해주세요
        </p>
      </div>
    </div>
  );
}

export default ShareCard;
